import { Cache } from 'aws-amplify';
import * as i0 from "@angular/core";
/**
 * Provides the current machine for the route. Uses resolved route data first (from URL machineId)
 * so each tab shows the correct machine when multiple machine tabs are open. Falls back to
 * Cache only when not on a /machine/:machineId route (e.g. legacy or external deep links).
 */
var MachineRouteService = /** @class */ (function () {
    function MachineRouteService() {
    }
    /**
     * Get the machine for the current route. Prefer route data (from resolver) over shared Cache
     * so multiple tabs with different machineIds don't overwrite each other.
     * Walks the route tree so it works regardless of nesting depth.
     */
    MachineRouteService.prototype.getMachine = function (route) {
        var fromRoute = this.getMachineFromRouteTree(route);
        if (fromRoute) {
            return fromRoute;
        }
        return Cache.getItem('selected_machine');
    };
    /**
     * Find machine in route data by walking the route tree (pathFromRoot).
     * Resilient to route structure changes.
     */
    MachineRouteService.prototype.getMachineFromRouteTree = function (route) {
        var current = route;
        while (current) {
            var data = current.snapshot.data['machine'];
            if (data) {
                return data;
            }
            current = current.parent;
        }
        return null;
    };
    MachineRouteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MachineRouteService_Factory() { return new MachineRouteService(); }, token: MachineRouteService, providedIn: "root" });
    return MachineRouteService;
}());
export { MachineRouteService };
